import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { BrandModal, useBrands, type Brand, type BrandResponse, BrandList, BrandListSkeleton } from "@/modules/brand";
import IconArrowLeftLane from "@/components/icons/icon-arrow-left-lane";
import { useAuth } from "@/modules/auth";
import { Link } from "react-router";
import Button from "@/components/ui/button";

export default function BrandsPage() {
	const { currentWorkspaceId, setWorkspaceId, updateProfile } = useAuth();
	const { brands, indexBrands } = useBrands();
	const [isLoading, setIsLoading] = useState(true);
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const fetchBrands = async () => {
			setIsLoading(true);
			await indexBrands();
			setIsLoading(false);
		};

		fetchBrands();
	}, [indexBrands]);

	const handleBrandCreated = (brand: Brand | BrandResponse) => {
		setWorkspaceId(brand.id);
		navigate(`/${brand.id}/dashboard`);
	};

	const handleBrandSwitch = async (brandId: string) => {
		await updateProfile({ current_workspace_id: brandId });
		setWorkspaceId(brandId);
		navigate(`/${brandId}/dashboard`);
	};

	return (
		<div className="py-12">
			<div className="space-y-4">
				{currentWorkspaceId && (
					<div className="mb-8">
						<Button as={Link} to={`/${currentWorkspaceId}/dashboard`} variant="soft" className="inline-flex items-center gap-2">
							<IconArrowLeftLane />
							Back to Selected Brand
						</Button>
					</div>
				)}

				<div className="flex items-start justify-between gap-4">
					<div>
						<h1 className="text-xl font-semibold text-primary -leading-[1%]">Brands</h1>
						<p className="text-sm mt-3 text-tertiary font-medium max-w-[640px]">Select a brand to switch to it, or create a new one.</p>
					</div>
					<Button variant="brand" className="inline-flex items-center gap-2" onClick={() => setIsCreateModalOpen(true)}>
						<svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
						</svg>
						Create Brand
					</Button>
				</div>
				{isLoading ? (
					<BrandListSkeleton />
				) : (
					<div className="py-4">
						{brands === null && (
							<div className="text-center py-8 text-gray-500">
								<p>No brands found. Create your first brand to get started.</p>
							</div>
						)}
						{brands !== null && (
							<BrandList brands={brands} currentWorkspaceId={currentWorkspaceId!} onSwitch={handleBrandSwitch} />
						)}
					</div>
				)}
			</div>

			<BrandModal mode="create" open={isCreateModalOpen} onOpenChange={setIsCreateModalOpen} onSuccess={handleBrandCreated} />
		</div>
	);
}
